import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Button } from 'react-bootstrap';

import CommonFormComponent from '../../CommonField/CommonFormComponent';

import submit from './submit';
import validate from './validate';
import messages from '../../../locale/jsonMessages';
import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';

import cp from '../../../components/commonStyle.css';
import s from './ListSettingsForm.css';

class AddListSettingsForm extends Component {

  static propTypes = {
    fieldType: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      fieldType: null
    }
  }

  UNSAFE_componentWillMount() {
    const { fieldType } = this.props;
    if (fieldType != undefined) {
      this.setState({ fieldType: fieldType });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { fieldType } = nextProps;
    if (fieldType != undefined) {
      this.setState({ fieldType: fieldType });
    }
  }


  render() {
    const { error, handleSubmit, submitting, dispatch, typeId, initialValues, selectedLanguage } = this.props;
    const { listSettingsData, carModelListSettingsData } = this.props;
    const { formatMessage } = this.props.intl;
    const { fieldType } = this.state;
    let isListingData = listSettingsData && listSettingsData.listSettings;
    let isCarModelDetails = carModelListSettingsData && carModelListSettingsData.listSettings;
    let isChangeValue = isCarModelDetails && isCarModelDetails.filter(o => o.makeType == makeName);
    return (
      <form onSubmit={handleSubmit(submit)}>
        {error && <strong>{formatMessage(error)}</strong>}
        <div className="oneColumnGrid">
          {
            typeId && (typeId == 3) &&
            <Field
              name="makeType"
              type="text"
              inputClass='commonSelectField'
              component={CommonFormComponent}
              labelText={formatMessage(messages.makeLabel)}
              placeholder={formatMessage(messages.makeLabel)}
            >
              <option value="">{formatMessage(messages.selectLabel)}</option>
              {
                isListingData && isListingData.length > 0 && isListingData.map((item, key) => {
                  if (item.isEnable == 1) {
                    return <option key={key} value={item.id}>{item.itemName}</option>
                  }
                })
              }
            </Field>
          }

          <FieldArray
            name="dynamicItemName"
            component={FieldArrayComponent}
            selectedLanguage={selectedLanguage}
            fieldType={fieldType}
            typeId={typeId}
          />

          {
            fieldType == "numberType" &&
            <>
              <Field
                name="startValue"
                type="text"
                component={CommonFormComponent}
                inputClass='commonInputField'
                labelText={formatMessage(messages.startValue)}
                placeholder={formatMessage(messages.startValue)}
              />

              <Field
                name="endValue"
                type="text"
                component={CommonFormComponent}
                inputClass='commonInputField'
                labelText={formatMessage(messages.endValue)}
                placeholder={formatMessage(messages.endValue)}
              />
            </>
          }
        </div>
        <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
          <Button className={cx(cp.btnPrimary)} type="submit" disabled={submitting}>
            {formatMessage(messages.addLabel)}
          </Button>
        </div>
      </form>
    )
  }

}

AddListSettingsForm = reduxForm({
  form: "AddListSettingsForm", // a unique name for this form
  validate,
})(AddListSettingsForm);

// Decorate with connect to read form values
const selector = formValueSelector("AddListSettingsForm"); // <-- same as form name

const mapState = (state) => ({
  typeId: selector(state, 'typeId'),
  listSettingsData: state.adminListSettingsData.isCarDetails,
  carModelListSettingsData: state.adminListSettingsData.isCarModelDetails,
  makeName: selector(state, 'makeType'),
  selectedLanguage: selector(state, 'dynamicItemName'),
});

const mapDispatch = {
};

export default injectIntl(withStyles(cp, s)(connect(mapState, mapDispatch)(AddListSettingsForm)));